import { Button } from 'app/design/primitives/button';
import { RemoteError } from 'app/design/primitives/remote-error';
import { useScopedTranslation } from 'app/hooks/i18n';
import { type useCreateAddress } from 'app/network/address-mutations';
import { type useTranslation } from 'react-i18next';
import type { SelectedAddress } from './shared';

export const NeighbourhoodActions = ({
  addressCount,
  createError,
  deleteStatus,
  onDelete,
  onSave,
  saveState,
  selectedAddress,
  translateError,
}: {
  addressCount: number;
  createError: ReturnType<typeof useCreateAddress>['error'];
  deleteStatus: 'idle' | 'pending';
  onDelete: () => void;
  onSave: () => void;
  saveState: { availability: 'enabled' | 'disabled'; status: 'idle' | 'pending' };
  selectedAddress: SelectedAddress;
  translateError: ReturnType<typeof useTranslation>['t'];
}) => {
  const { t } = useScopedTranslation();
  return (
    <>
      {createError ? <RemoteError error={createError} message={translateError(createError.message)} /> : null}
      <Button
        disabled={saveState.availability === 'disabled'}
        loading={saveState.status === 'pending'}
        marginTop="spacing.general.x2"
        onPress={onSave}
        variant="primary"
      >
        {t(selectedAddress ? 'saveClubButton' : 'createClubButton')}
      </Button>
      {selectedAddress && addressCount > 1 ? (
        <Button loading={deleteStatus === 'pending'} onPress={onDelete} variant="secondary">
          {`${t('deleteButton')} ...`}
        </Button>
      ) : null}
    </>
  );
};
